import { reportCustomers } from './reportCustomers'
import { reportCommission } from './reportComissions'
import { reportCoupons } from './reportCoupons'
import { reportReferrals } from './reportReferral'
import { reportSellers } from './reportSellers'
import { reportSupports } from './reportSupports'
import { reportTeams } from './reportTeams'
import { reportTransaction } from './reportTransactions'
import { reportWithdraws } from './reportWithdraws'

export const reportService = {
  reportTransaction,
  reportCommission,
  reportWithdraws,
  reportCoupons,
  reportSellers,
  reportTeams,
  reportReferrals,
  reportSupports,
  reportCustomers,
}
